import { useEffect } from 'react';
import bugsnagClient from 'containers/BugsnagClient';
import toast from 'react-hot-toast';

// Kept out of useFilter so that hook stays effect-free — it is mounted several
// times per page. Several reporters collapse to one toast (fixed id) and one
// Bugsnag report per distinct set.
const reported = new Set();
const useStaleFilterNotice = (staleFilters) => {
    const key = Object.keys(staleFilters || {}).length
        ? JSON.stringify(staleFilters)
        : '';
    useEffect(() => {
        if (!key) return;
        toast.error(
            'Some filters in this link are no longer available and were skipped — update your saved link.',
            { id: 'stale-filter', position: 'top-right', duration: 7000 },
        );
        if (reported.has(key)) return;
        reported.add(key);
        bugsnagClient.notify(
            new Error(`Ignored unknown URL filter value(s): ${key}`),
        );
    }, [key]);
};

export default useStaleFilterNotice;
